import axios from "axios";
import { BASE_URL } from "./api";

export async function whitelistEmail(token, emailId, data){
    return axios({
    method: "patch",
    url: `${BASE_URL}/person_email/${emailId}/whitelist_email/`,
    headers: {
      Authorization: `Token ${token}`,
    },
    data: data
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.log(error);
    });
}